import { BreadCrumbs, ISearchProduct } from '@/interfaces/product';

export const getTextWidth = (text: string, font: string, margin = 35, transform = 35): number => {
  if (globalThis.window === undefined) {
    return 0; // Return 0 during SSR
  }

  margin = margin === 40 ? 35 : margin;
  transform = transform === 40 ? 35 : transform;
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  if (context) {
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width + margin + transform;
  }
  return 0;
};

export const stripHTML = (content?: string) => {
  return (content || '').replace(/(<([^>]+)>)/gi, '');
};

export const generateRandomeArray = (item: any) => {
  const products: any = [];
  for (let i = 0; i < 12; i++) {
    products.push(item);
  }
  return products;
};

export const popupCenter = (url: string, title: string) => {
  if (globalThis.window === undefined) {
    return; // Do nothing during SSR
  }

  const dualScreenLeft = window.screenLeft ?? window.screenX;
  const dualScreenTop = window.screenTop ?? window.screenY;

  const width = window.innerWidth ?? document.documentElement.clientWidth ?? screen.width;

  const height = window.innerHeight ?? document.documentElement.clientHeight ?? screen.height;

  const systemZoom = width / window.screen.availWidth;

  const left = (width - 500) / 2 / systemZoom + dualScreenLeft;
  const top = (height - 550) / 2 / systemZoom + dualScreenTop;

  const newWindow = window.open(url, title, `width=${500 / systemZoom},height=${550 / systemZoom},top=${top},left=${left}`);

  newWindow?.focus();
};

export const getEnumKey = (enumObject: any, enumValue: any) => {
  return Object.keys(enumObject).find((key) => enumObject[key] === enumValue);
};

export function getDateString(date: string) {
  const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  const dateFormat = new Date(date);
  const day = dateFormat.getDate();
  const month = monthNames[dateFormat.getMonth()];
  const year = dateFormat.getFullYear();
  const updatedFormat = `${day} ${month} ${year}`;

  return updatedFormat;
}

export function capitalizeFirstLetter(data: string) {
  return data.charAt(0).toUpperCase() + data.slice(1);
}

export function numberFormat(price: number | string | undefined) {
  return price && new Intl.NumberFormat('en-IN').format(+price || 0);
}

export function calculateDiscountPercentage(newPrice: number, oldPrice: number) {
  let discountPercent = ((oldPrice - newPrice) / oldPrice) * 100;
  return `${Math.ceil(discountPercent)}% off`;
}

export function clearAllCookies() {
      if (globalThis.window === undefined) {

    return; // Do nothing during SSR
  }

  const cookies = document.cookie?.split('; ');

  for (const cookie of cookies) {
    const [name, _] = cookie?.split('=');
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
}

export const setProductPosition = (productList: ISearchProduct, isTab: boolean | null, rightPosition: number) => {
  const leftLargeProductPosition: number[] = [];
  const rightLargeProductPosition: number[] = [];
  let leftPosition = 0;

  productList?.Products?.map((_, index: number) => {
    if (leftPosition == index) {
      leftLargeProductPosition.push(index);
      if (isTab) {
        leftPosition += 12;
      } else {
        leftPosition += 18;
      }
    } else if (rightPosition == index) {
      rightLargeProductPosition.push(index);
      if (isTab) {
        rightPosition += 12;
      } else {
        rightPosition += 18;
      }
    }
  });
  return [leftLargeProductPosition, rightLargeProductPosition];
};

export const getYoutubeIdFromUrl = (link?: string): string | false => {
  if (!link) {
    return false;
  }
  const youtubeIdRegex =
    /^(?:(?:https|http):\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be).*?(?:\/|v\/|u\/|embed\/|shorts\/|watch\?v=|(?<username>user\/))(?<id>[\w\-]{11})(?:\?|&|$)/;

  const match = link.match(youtubeIdRegex);

  // checks if 'user/' is located right before expected id, in which case it would return username instead
  if (match?.groups?.username || !match?.groups?.id) {
    return false;
  }
  return match.groups.id;
};
export const link = (type: 'Category' | 'Brand' | 'Text' | 'Auxiliary' | 'Link', seName?: string, filters?: any, relativeLink?: string) => {
  if (filters?.gender?.includes('Unisex')) {
    delete filters['gender'];
  }
  if (type === 'Brand' || type === 'Category') {
    if (filters && Object.keys(filters).length > 0) {
      let stringifiedFilter = JSON.stringify(filters);
      let eoncodedStringifiedFilter = stringifiedFilter.replaceAll(/"/g, '_')?.replaceAll(/:/g, '~');

      return `/${type.toLowerCase()}/${seName}/${eoncodedStringifiedFilter}?filters=${stringifiedFilter}`;
    } else {
      return `/${type.toLowerCase()}/${seName}`;
    }
  } else if (type === 'Link') {
    if (relativeLink) {
      var queryString: { [key: string]: string } = {};
      relativeLink.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), (param1: string, param2: string, param3: string, param4: string) => {
        return (queryString[param2] = param4);
      });
      let sortByString = '';
      if (queryString.sortby) {
        sortByString += 'sortby=' + queryString.sortby;
      }
      let eoncodedStringifiedFilter = '';
      if (queryString.filters) {
        eoncodedStringifiedFilter = queryString.filters.replaceAll(/"/g, '_')?.replaceAll(/:/g, '~');
      }
      const splitModuleAndSubmodule = Object.keys(queryString)[0]?.split('/');
      const module = splitModuleAndSubmodule?.[0];
      const subModule = splitModuleAndSubmodule?.[1];

      return `/${module}/${subModule}/${eoncodedStringifiedFilter + (eoncodedStringifiedFilter ? '&' + sortByString : sortByString)}${
        (queryString.filters ? '?filters=' + queryString.filters : '') + (queryString.filters ? '&' + sortByString : '?' + sortByString)
      }`;
    } else {
      return `/${relativeLink}`;
    }
  }
  return '';
};

export const checkedValue = (selectedValue: string[], value: string) => {
  if (selectedValue?.length > 0) {
    return selectedValue.includes(value);
  } else {
    return false;
  }
};

export const getBreadcrumbData = (bred: BreadCrumbs[]) => {
  if (!bred || bred.length === 0) return [];

  const breadcrumbData = [
    {
      position: 1,
      name: 'Home',
      item: '/',
    },
  ];

  bred.forEach((bredItem, index) => {
    breadcrumbData.push({
      position: index + 2,
      name: bredItem.Name ? bredItem.Name : '',
      item: `/${bredItem.IsCategory ? 'category' : 'brand'}/${bredItem.SeName}`,
    });
  });

  return breadcrumbData;
};

// Set a cookie
export const setCookie = (name: string, value: string, days = 365) => {
      if (globalThis.window === undefined) {

    return; // Do nothing during SSR
  }

  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/`;
};

// Get a cookie
export const getCookie = (name: string): boolean => {
      if (globalThis.window === undefined) {

    return false; // Return false during SSR
  }

  console.log(document.cookie.split('; '));

  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [key, value] = cookie.split('=');

    if (key === name) return true;
  }
  return false;
};

// Remove a cookie
export const removeCookie = (name: string) => {
  if (globalThis.window === undefined) {
    return; // Do nothing during SSR
  }

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

// Check menu category is available
export const isSubmoduleAvailable = (data: any, submodule: string) => {
  if (!data) return false;

  // Check if the current object's `SeName` matches
  if (data.SeName === submodule) return true;

  // Check in `Items` array (if available)
  if (data.Items && data.Items.length > 0) {
    for (const item of data.Items) {
      if (isSubmoduleAvailable(item, submodule)) {
        return true;
      }
    }
  }

  // Check in `Brands` array (if available)
  if (data.Brands && data.Brands.length > 0) {
    for (const brand of data.Brands) {
      if (isSubmoduleAvailable(brand, submodule)) {
        return true;
      }
    }
  }

  return false;
};

/**
 * @param date - Raw Date object (with time) or null
 * @param time - (Optional) Time string in the format of "HH:MM" 24H format
 * @returns ISO string of the date and time
 */
export const getTimeISOString = (date?: Date | null, time?: string) => {
  let dateTime: Date;

  if (date) {
    dateTime = date;
  } else {
    // If user does not select a date, use current date.
    dateTime = new Date();
  }

  if (!time) {
    // If user does not select a time, return the date in ISO string as it is.
    return dateTime.toISOString();
  }

  const [hours, minutes] = time.split(':').map(Number);

  dateTime.setHours(hours, minutes, 0, 0);
  //If user selects a time, return the date in ISO string with the time added.
  return dateTime.toISOString();
};


export const getKeys = <T extends Record<string, any>>(obj: T | null | undefined): string[] => {
  return obj ? Object.keys(obj) : [];
};

export const getValues = <T extends Record<string, any>>(obj: T | null | undefined): any[] => {
  return obj ? Object.values(obj) : [];
};

const getDefaultPriceRange = (priceRange: any) => ({
  minPrice: priceRange?.Min ? Math.floor(priceRange.Min) : 0,
  maxPrice: priceRange?.Max ? Math.ceil(priceRange.Max) : 0,
});

const parsePriceFromQuery = (priceFromQuery: string) => {
  const priceParts = priceFromQuery.split(' ');
  return {
    minFromQuery: priceParts[0],
    maxFromQuery: priceParts[2],
  };
};

export const getInitialPrice = (filters: any, priceRange: any) => {
  // If no filters, return default values
  if (!filters) {
    return getDefaultPriceRange(priceRange);
  }

  try {
    const filtersFromQuery = JSON.parse(filters.toString());
    const priceFromQuery = filtersFromQuery?.price?.[0];
    
    if (!priceFromQuery) {
      return getDefaultPriceRange(priceRange);
    }

    const { minFromQuery, maxFromQuery } = parsePriceFromQuery(priceFromQuery);
    const defaultRange = getDefaultPriceRange(priceRange);

    return {
      minPrice: minFromQuery ? +minFromQuery : defaultRange.minPrice,
      maxPrice: maxFromQuery ? +maxFromQuery : defaultRange.maxPrice,
    };
  } catch (e) {
    console.error('Error parsing filters:', e);
    return getDefaultPriceRange(priceRange);
  }
};

export const getContainerClassName = (asContent: boolean, baseClasses: string, asContentClass: string): string => {
  return asContent ? baseClasses : `${baseClasses} ${asContentClass}`;
};

export const getHeaderPanelClassName = (cartPanel: boolean, searchPanel: boolean, filterPanel: boolean) => {
  const zIndex = (cartPanel || searchPanel || filterPanel) ? 'z-10' : 'z-[200]';
  return `relative ${zIndex} hidden bg-[#f5f5f5] font-semibold lg:block`;
};

export const getPanelStyle = (translateHeader: boolean, navPanel: boolean) => {
  if (translateHeader && !navPanel) {
    return { transform: 'translateY(calc(-1 * var(--header-height)))' };
  }
  return {};
};

export const getHeaderClassName = (navPanel: boolean, banner: boolean) => {
  const baseClasses = 'top-0 w-full max-md:fixed md:sticky z-[100] static-bg';
  const classes = [baseClasses];
  
  if (navPanel) classes.push('nav-open');
  if (banner) classes.push('home');
  
  return classes.join(' ');
};

